import React, { useContext, useEffect } from "react";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import Loader from "../../components/Loader";
import Table from "../../components/Table";
import { Link } from "react-router-dom";
import { webexIoTColumn } from "../../components/headerContent";
import RowWebexIoT from "./RowWebexIoT";
import { useTranslation } from "react-i18next";

const storybookWorkspacesFallback = {
    items: [
        {
            id: "ws-01",
            displayName: "Innovation Lab",
            type: "meetingRoom",
            capacity: 12,
            created: "2026-01-12T09:00:00.000Z",
            storybookMetrics: [
                { metricName: "temperature", workspaceId: "ws-01", items: [{ min: 20, max: 24, mean: 22 }] },
                { metricName: "humidity", workspaceId: "ws-01", items: [{ min: 38, max: 49, mean: 42 }] },
                { metricName: "peopleCount", workspaceId: "ws-01", items: [{ min: 2, max: 8, mean: 5 }] }
            ]
        },
        {
            id: "ws-02",
            displayName: "Boardroom",
            type: "conference",
            capacity: 18,
            created: "2026-02-01T10:30:00.000Z",
            storybookMetrics: [
                { metricName: "soundLevel", workspaceId: "ws-02", items: [{ min: 31, max: 48, mean: 39 }] },
                { metricName: "ambientNoise", workspaceId: "ws-02", items: [{ min: 22, max: 40, mean: 30 }] },
                { metricName: "peopleCount", workspaceId: "ws-02", items: [{ min: 4, max: 12, mean: 7 }] }
            ]
        },
        {
            id: "ws-03",
            displayName: "Customer Experience Room",
            type: "focus",
            capacity: 6,
            created: "2026-02-18T08:15:00.000Z",
            storybookMetrics: [
                { metricName: "temperature", workspaceId: "ws-03", items: [{ min: 19, max: 23, mean: 21 }] },
                { metricName: "tvoc", workspaceId: "ws-03", items: [{ min: 180, max: 260, mean: 220 }] }
            ]
        }
    ]
};

export default function WebexIot() {
    const { apiUrl, user } = useContext(AuthContext);
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    const getWorkspacesWebex = async () => {
        try {
            const res = await axios.get(`${apiUrl}webex/workspaces`, {
                withCredentials: true
            });
            if (res.data?.items?.length > 0) {
                return res.data;
            }
            if (apiUrl === "/") {
                return storybookWorkspacesFallback;
            }
            return res.data;
        } catch (error) {
            if (apiUrl === "/") {
                return storybookWorkspacesFallback;
            }
        }
    }

    const webexWorkspaces = useQuery({
        queryKey: ["webexWorkspaces"],
        queryFn: getWorkspacesWebex
    })

    useEffect(() => {
        queryClient.invalidateQueries(["webexWorkspaces", webexWorkspaces.data]);
    }, [webexWorkspaces.data]);

    const workspaces = Array.isArray(webexWorkspaces.data?.items) ? webexWorkspaces.data.items : [];

    if (webexWorkspaces.isFetched) {
        if (!webexWorkspaces.data || webexWorkspaces.data[0] === 'No data') {
            return (
                <div className="ecp-container">
                    <div className="ecp-container-content-error">
                        <div className="error-container">
                            <img src='../assets/ecp_error.svg' alt="icône d'erreur" />
                            <div className="error-container-text">
                                <h1 className="page-title">
                                    {t("Aucun équipements détectées")}
                                </h1>
                                <p className="page-link_home">
                                    <Link to="/"> {t("Revenir à l'accueil")}</Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    return (
        <>
            {!webexWorkspaces.isLoading ?
                <div className='cato-content-table mt-1'>
                    <Table
                        tableColumns={webexIoTColumn}
                        tableData={workspaces}
                        rowComponent={RowWebexIoT}
                    />
                </div>
                : <Loader />
            }
        </>
    )
}
